<template>
  <div class="view-form fh">
    <div class="fh center" v-if="loadEditForm">
      <loading-circle />
    </div>
    <div v-else class="fh">
    <div class="view-form--nav module-header v-center space-between">
      <div class="flex gap-1">
        <img
            src="~@/assets/images/icons/arrow-back.svg"
            width="20"
            class="go-back"
            @click="goBack"
          />
          <div>
            <h2 class="module-name v-center">
              {{ formTemplateData?.name }} <div class="form-type"> <span class="header-default-dot">.</span> {{ formTemplateData?.core_form_type?.name }}</div>
            </h2>
          <div v-if="templateField" class="form-header-default">
              <span class="header-default-label">Created <span class="header-default-value">{{ getValuesFromForm('created_by') }}</span></span>
              <span class="header-default-label"> <span class="header-default-dot">.</span><span class="header-default-value">{{ getValuesFromForm('created_on') }}</span></span> &ensp;
              <span class="header-default-label" v-if="getValuesFromForm('updated_by')"> Updated <span class="header-default-value">{{ getValuesFromForm('updated_by') }}</span></span>
              <span class="header-default-label" v-if="getValuesFromForm('updated_by')"> <span class="header-default-dot">.</span><span class="header-default-value">{{ getValuesFromForm('updated_on') }}</span></span>
            </div>
          </div>
    </div>
        <div class="v-center flex-end py-3">
            <button class="btn btn-cancel mx-2" @click="goBack">Cancel</button>
            <button class="btn mx-2" @click="UpdateForm(config.FORM_STATE_MAP.DRAFT)" v-if="currentStatus===config.FORM_STATE_MAP.DRAFT">Save as Draft</button>
            <!-- this button will update form as open state -->
            <button class="btn mx-2" @click="handleDraftSubmit" :disabled="stepWithNoUsers.length > 0" v-if="currentStatus===config.FORM_STATE_MAP.DRAFT" >Submit Form</button>
            <button class="btn mx-2" @click="UpdateForm(currentStatus)"  v-if="showUpdateFormBtn && (currentStatus===config.FORM_STATE_MAP.OPEN || currentStatus===config.FORM_STATE_MAP.REOPENED)">Update</button>
            <!-- // only if no attached workfow is null then only we can close the form -->
            <button class="btn mx-2" @click="UpdateForm(config.FORM_STATE_MAP.CLOSED)"  v-if="(currentStatus===config.FORM_STATE_MAP.OPEN || currentStatus===config.FORM_STATE_MAP.REOPENED) && !workflowId && this.formData.form_type_id !== 5 && !collaborator" >Close Form</button>
            <!-- <button class="btn mx-2" @click="UpdateForm(config.FORM_STATE_MAP.REOPENED)"  v-if="currentStatus===config.FORM_STATE_MAP.CLOSED" >Reopen Form</button> -->
            <!-- <button class="btn mx-2" @click="UpdateForm(config.FORM_STATE_MAP.REOPENED)"  v-if="workflowData.workflow_stage?.end_step && config.FORM_STATE_MAP.REOPENED" >Update </button> -->
             <!-- rubiya is working on enable new revision in reopened forms  -->
        </div>
      </div>
      <div class="view-form--maincontainer">
      <div class="view-form--container">
        <div class="fh center" v-if="loading">
      <loading-circle />
    </div>
        <div v-else class="view-form--elements">
           <div class="form-autogenerated"  >
              <div class="span-div" v-if="formData.sequence_value">
                <span class="label">Sequence ID</span>
                <span class="value">
                  {{ formData.sequence_value }}
                  </span>
                  </div>
            <template v-for="(ele, index) in templateField">
              <div class="span-div" :key="index" v-if="ele.autogenerated &&  (ele.field_name !== 'project' || formData.project_id) && getkeysFromForm(ele.field_name)">
                <span class="label" >{{getkeysFromForm(ele.field_name)}}:</span>
                <div class="value">{{getValuesFromForm(ele.field_name)}}</div>
              </div>
            </template>
          </div>
            <div class="mb-2">
              <part-id-preview :components="partIdRules" v-if="partIdRules.length && !formData.sequence_value && currentStatus===config.FORM_STATE_MAP.DRAFT" @update="updatePartIdValues" title="Sequence Id Preview"/>
            </div>
              <div class="form-grid">
                <div class="form-grid__item" :class="getComponentGridClass('DATE')">
                  <div :class="{
                    'form-input': true,
                    'form-input--required': true,
                    'form-input--explicit-asterisk': true
                  }" data-validation="dueDate">
                    <label class="form-input__label">
                      <span class="form-input__caption">Due Date<span class="form-input__asterisk">*</span></span>
                    </label>
                    <input v-model="convertDueDate" type="date" :min="currentDate" @change="changeInDueDate = true" :disabled="!updateFormDetails"/>
                  </div>
                </div>
                <template v-for="(ele, index) in templateField">
                  <div
                    v-if="!ele.autogenerated && (ele.form_field.key !== 'BOM' || isOnProjectLevel) && (ele.form_field.key !== 'DOCUMENTS' || currentStatus===config.FORM_STATE_MAP.DRAFT)"
                    :key="index"
                    :class="['form-grid__item', getComponentGridClass(ele.form_field.key)]"
                  >
                    <component
                      :ref="ele.field_id"
                      :fieldId="ele.field_id"
                      :formTypeId="formData?.form_type_id"
                      :is="ele.form_field.key + '_COMPONENT'"
                      :data="ele"
                      mode="EDIT"
                      :formStatus="formData.status"
                      :value="formValueData[ele.field_id]"
                      :viewOnly="!updateFormDetails"
                      @customChange="handleInputChange"
                      :formTemplate="true"
                      :isFormMode="ele.form_field.key === 'TABLE'"
                      :formData="formData"
              :factoryId="formData?.core_factory?.id"
              :jofParentMaterialUpdate="jofParentMaterialUpdate"
              @confirmJofSubmit="confirmJofSubmit"
                    />
                  </div>
                </template>
              </div>
        </div>
      </div>
      <div class="view-form--sideBar">
        <div class="tab-headers">
      <div
        v-for="(tab, index) in visibleTabs"
        :key="index"
        :class="['tab-header', { active: selectedTab === tab.id }]"
        @click="selectTab(tab.id)"
      >
        {{ tab?.name }}
      </div>
    </div>
    <div v-if="selectedTab ===  config.FORM_TAB_STATUS.REVISION_HISTORY || selectedTab ===  config.FORM_TAB_STATUS.HISTORY" class="tab-body-parent">
      <version-history :rootFormId="formData.root_parent_id" :formTypeId="formData.form_type_id" @selectedVersion="getFormData" :instanceId="wfInstaceId" :formId="formData.id" :viewOnly="true" :selectedTab="selectedTab"/>
    </div>
    <div v-if="selectedTab ===  config.FORM_TAB_STATUS.COMMENTS">
      <form-comment-panel
        :form="formData"
        :disabled="true"
        @closeComment="openComment = false"
        :closeOnOutsideClick = true
      />
    </div>
    <div class="fh center" v-if="sideBarLoading">
      <loading-circle />
    </div>
    <div v-else-if="formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF && selectedTab === config.FORM_TAB_STATUS.WORKFLOW && !wfInstaceId">
   <process-plan-list :mode="formData.status === config.FORM_STATE_MAP.DRAFT ? 'draft' : 'edit' "
   :material-process-plan-links="materialLinks"
   :material-names="materialNames"
   :material-id-to-detail-map="materialIdToDetailMap"
   :createdByUserId="formData.created_by"
   @refreshData="fetchMaterialLinks"
   @showWfInstanceDetails="showWfInstanceDetails"
   :active-material="activeMaterial" @selectActiveMaterial = "(material) => activeMaterial = material"
   />
    </div>
  <workflow-instance-edit-panel
    v-if="wfInstaceId && selectedTab === config.FORM_TAB_STATUS.WORKFLOW"
    ref="WorkflowDetailsPanel"
    :formId="formData.id"
    :formStatus="formData.status"
    :formTypeId="formData.form_type_id"
    :formCreatedBy="formData.created_by"
    :formTemplateTypeId="formTemplateData.core_form_type.id"
    :wfInstanceId="wfInstaceId"
    :selected-material="selectedMaterial"
    :documentField="documentField"
    :showUpdateFormBtn="showUpdateFormBtn"
    :folderId="folderId"
    :factoryData="{id: formData.factory_id, name: formData?.core_factory?.name}"
    @afterWFaction="fetchMaterialLinks"
    @goBack="goBackFromWorkflowDetails"
    @loadWorkflowData="loadWorkflowData"
    @finishWorkflow="UpdateForm(config.FORM_STATE_MAP.CLOSED, true)"
  >
  </workflow-instance-edit-panel>
    <div v-else-if="showWorkFlowStepSelection">
<workflow-starting-stp-selection
:wftStartStages="wftStartStages"
:selectedStartingStep="selectedStartingStep"
:templateId="workflowId"
:templateVersionId="workFlowVersionId"
:wfTypeName="wfTypeName"
:selectedUserGroup="selectedUserGroup"
@selectStartingStep="addSelectedStep"
@removeSelection="()=>selectedStartingStep=null"
@handleUserSelection="handleUserSelection"
/>
    </div>
  </div>
  </div>
  </div>
  </div>
</template>

<script>
import { getDetailFormTemplate, GetFormDataByFormId, EditForm, getGivenCustomListsData, GetJobOrderMaterialLinksInst, alterFlattenedBomMaterialsApi } from '@/api'
import { mapGetters } from 'vuex'
import { timeStampToDate } from '@/filters/dateFilter'
import { formatMaterailData, getFieldIds, GetFormValueMap, isMatDataChange } from '@/helper/formValue.js'
import { alert, success, warning } from '@/plugins/notification'
import { genericFormatDate } from '@/utils/date'
import modal from '@/components/common/modal.vue'
import timeComponent from '@/components/form/elements/timeComponent.vue'
import configurationList from '@/components/form/elements/configurationList.vue'
import fileComponent from '@/components/form/elements/fileComponent.vue'
import dateComponent from '@/components/form/elements/dateComponent.vue'
import longTextComponent from '@/components/form/elements/longTextComponent.vue'
import numberComponent from '@/components/form/elements/numberComponent.vue'
import switchComponent from '@/components/form/elements/switchComponent.vue'
import textComponent from '@/components/form/elements/textComponent.vue'
import companyComponent from '@/components/form/elements/companyComponent.vue'
import userComponent from '@/components/form/elements/userComponent.vue'
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import materialComponent from '@/components/form/elements/materialComponent.vue'
import locationComponent from '@/components/form/elements/locationComponent.vue'
import LoadingCircle from '../../components/common/loadingCircle.vue'
import productCodeComponent from '@/components/form/elements/productCodeComponent.vue'
import FormCommentPanel from '../../components/form/formCommentPanel.vue'
import bomComponent from '@/components/form/elements/bomComponent.vue'
import tagsComponent from '@/components/form/elements/tagsComponent.vue'
import contactListComponent from '@/components/form/elements/contactListComponent.vue'
import customDropdown from '@/components/common/customDropdown.vue'
import documentsComponent from '@/components/form/elements/documentsComponent.vue'
import userSelectionForWf from '@/components/form/userSelectionForWf.vue'
import Loader from '@/plugins/loader'
import versionHistory from './versionHistory.vue'
import config from '@/config'
import confirmationDialog from '@/plugins/confirmationDialog'
import { getWorkflowStepWithUsers } from '@/api/apis/workflows'
import workflowStartingStpSelection from '@/components/form/workflowStartingStpSelection.vue'
import Avatar from '@/components/common/avatar.vue'
import partIdPreview from '@/components/common/partIdPreview.vue'
import processPlanList from './processPlanList.vue'
import WorkflowInstanceEditPanel from './workflowInstanceEditPanel.vue'
import { validateWorkflowBeforeProceed } from './formhelperFunctions'
import { getWorkflowUserMappings } from './wfInstanceEditHelper'
import tableTemplate from '../SETTINGS/tableTemplate.vue'
import errorBorder, { removeErrorBorder } from '@/helper/formValidation/errorBorder'
const componentAlignment = {
  BOOLEAN: 1,
  NUMBER: 1,
  TEXT: 1,
  LONG_TEXT: 2,
  DATE: 1,
  TIME: 1,
  CONFIGURATION_LIST: 1,
  ATTACHMENT: 2,
  COMPANY: 1,
  USER: 1,
  MULTI_USER: 2,
  MATERIALS: 2,
  LOCATION: 2,
  PRODUCT_CODE: 1,
  BOM: 2,
  TAGS: 2,
  CONTACT_LIST: 2,
  DOCUMENTS: 2,
  TABLE: 2
}
export default {
  name: 'EditFormComponent',
  components: {
    BOOLEAN_COMPONENT: switchComponent,
    NUMBER_COMPONENT: numberComponent,
    TEXT_COMPONENT: textComponent,
    LONG_TEXT_COMPONENT: longTextComponent,
    DATE_COMPONENT: dateComponent,
    TIME_COMPONENT: timeComponent,
    CONFIGURATION_LIST_COMPONENT: configurationList,
    ATTACHMENT_COMPONENT: fileComponent,
    COMPANY_COMPONENT: companyComponent,
    USER_COMPONENT: userComponent,
    MULTI_USER_COMPONENT: multiUserComponent,
    MATERIALS_COMPONENT: materialComponent,
    LOCATION_COMPONENT: locationComponent,
    PRODUCT_CODE_COMPONENT: productCodeComponent,
    BOM_COMPONENT: bomComponent,
    TAGS_COMPONENT: tagsComponent,
    CONTACT_LIST_COMPONENT: contactListComponent,
    DOCUMENTS_COMPONENT: documentsComponent,
    TABLE_COMPONENT: tableTemplate,
    LoadingCircle,
    FormCommentPanel,
    versionHistory,
    workflowStartingStpSelection,
    customDropdown,
    userSelectionForWf,
    modal,
    Avatar,
    partIdPreview,
    processPlanList,
    WorkflowInstanceEditPanel
  },
  filters: {
    timeStampToDate,
    genericFormatDate,
    statusfomat (value) {
      if (!value) return ''
      return value.replace(/_/g, ' ')
    },
    getQCStatusName (value) {
      if (!value) return ''
      else if (value === config.FORM_STATE_MAP.APPROVED) return 'Approved'
      else if (value === config.FORM_STATE_MAP.REJECTED) return 'Rejected'
      else if (value === config.FORM_STATE_MAP.HOLD) return 'Hold'
      else if (value === config.FORM_STATE_MAP.IN_PROGRESS) return 'In Progress'
    }
  },
  data () {
    return {
      activeMaterial: '',
      materialNames: [],
      materialLinks: [],
      materialIdToDetailMap: {},
      formattedIndependentUsers: [],
      formattedIndependentUsersExceededCount: 0,
      partIdRules: [],
      partIdValues: {},
      sideBarLoading: false,
      formSequenceTemplate: {},
      folderId: null,
      fileSize: 0,
      files: [],
      existingFiles: [],
      currentDate: new Date().toLocaleDateString('en-CA'),
      validationErrors: [],
      templateId: '',
      templateName: '',
      formTemplateData: {},
      formData: {},
      currentStatus: '',
      formValueData: {},
      loading: false,
      openComment: false,
      convertDueDate: '',
      changeInDueDate: false,
      metadataPayloadValueMap: {},
      config: config,
      workflowId: null,
      workflowData: {},
      wfInstaceId: null,
      selectedTab: 1,
      loadEditForm: false,
      stepWithNoUsers: {},
      workFlowVersionId: null,
      selectedMaterial: {
        name: '',
        number: null
      },
      tabs: [
        {
          id: 1,
          name: 'WorkFlow'
        },
        {
          id: 2,
          name: 'Comments'
        },
        {
          id: 3,
          name: 'Version History'
        },
        {
          id: 4,
          name: 'History'
        }
      ],
      wftStartStages: [],
      selectedStartingStep: null,
      wfTypeName: '',
      wFStartStepUsers: [], // thisis to store the users selected for the next step
      parentInstanceId: null,
      existingUsers: null,
      selectedUserGroup: [],
      instanceStepDocs: [], // this is to store the documents attached to the workflow instance steps except the current step
      openResourceItemModal: false,
      selectedResource: null
    }
  },
  computed: {
    ...mapGetters(['user', 'isOnProjectLevel', 'tenantUsersList', 'currentProject', 'tenantList', 'collaborator']),
    ...mapGetters(['isExternalCollaborator']),
    visibleTabs () {
      return this.tabs.filter(tab => {
        if (this.formData.form_type_id === 5 && tab.name === 'Version History') return false
        if (tab.name === 'WorkFlow') {
          if (!this.wfInstaceId && !this.workflowId && config.FORM_STATE_MAP.DRAFT !== this.currentStatus && this.formData.form_type_id !== this.config.FORM_TEMPLATE_TYPE.JOF) return false
          else if (!this.workflowId && this.formData.form_type_id !== this.config.FORM_TEMPLATE_TYPE.JOF) return false
        }
        return true
      })
    },
    formVersion () {
      return this.formTemplateData?.template_versions?.find(
        (item) => item.id === this.formData.template_version_id
      )
    },
    documentField () {
      return this.templateField.find(
        (ele) => ele.form_field.key === 'DOCUMENTS'
      )
    },
    templateField () {
      return this.formVersion?.template_fields
    },
    showWorkFlowStepSelection () {
      return this.workflowId && !this.wfInstaceId && this.currentStatus === config.FORM_STATE_MAP.DRAFT && this.selectedTab === config.FORM_TAB_STATUS.WORKFLOW
    },
    updateFormDetails () {
      const isAdmin = this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN'
      const isAssigned = this.formData?.forms_user_lists?.some(a => a.user_id === this.user.userId)
      const isCreator = this.formData?.created_by === this.user.userId
      return isAdmin || isAssigned || isCreator
    },
    showUpdateFormBtn () {
      if (this.formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF && this.currentStatus === config.FORM_STATE_MAP.OPEN) {
        // admin check
        if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
          return true
          // creator check
        } else if (this.formData.created_by_user.id === this.user.userId && (this.user.tenantLevelRole === 'COLLABORATOR' || this.user.projectLevelRole === 'COLLABORATOR')) {
          return true
        // form assignees check
        } else if ((this.user.tenantLevelRole !== 'VIEWER' || this.user.projectLevelRole !== 'VIEWER') && this.formData.forms_user_lists.length > 0) {
          return this.formData.forms_user_lists.some(
            assignee => assignee.user_id === this.user.userId
          )
        }
        return false
        // jof with draft form check
      } else if (this.formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF && this.currentStatus === config.FORM_STATE_MAP.DRAFT) {
        if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
          return true
          // creator check
        } else if (this.formData.created_by_user.id === this.user.userId && (this.user.tenantLevelRole === 'COLLABORATOR' || this.user.projectLevelRole === 'COLLABORATOR')) {
          return true
        }
      } else if (this.currentStatus === config.FORM_STATE_MAP.OPEN || this.currentStatus === config.FORM_STATE_MAP.REOPENED || this.currentStatus === config.FORM_STATE_MAP.DRAFT) {
        return true
      }
      return false
    }
  },
  methods: {
    getRealTimeMaterialsData () {
      const materialField = this.templateField.find(
        (field) => field?.form_field?.key === 'MATERIALS'
      )

      let completeMaterialData = []
      let materialDetailsMap = {}

      if (materialField && this.$refs[materialField.field_id]) {
        const matComponent = this.$refs[materialField.field_id][0]
        completeMaterialData = matComponent.componentValue || []
        materialDetailsMap = matComponent.selectedMaterialsMap || {}
      }

      return completeMaterialData.map(material => ({
        materialName: materialDetailsMap[material.material_id]?.material_name || '',
        materialCode: materialDetailsMap[material.material_id]?.custom_material_id || '',
        uom: materialDetailsMap[material.material_id]?.unit_of_material || '',
        totalQuantity: material.quantity || 0,
        materialId: material.material_id
      }))
    },
    handleCloseFormClick () {
      if (this.formData.form_type_id === this.config.FORM_TEMPLATE_TYPE.GRF && !this.workflowId) {
        this.materialAllocationData = this.getRealTimeMaterialsData()

        if (!this.materialAllocationData || this.materialAllocationData.length === 0) {
          alert('Please add at least one material to the form before closing.')
          return
        }

        const totalQty = this.materialAllocationData.reduce((sum, item) => sum + (Number(item.totalQuantity) || 0), 0)
        if (totalQty <= 0) {
          alert('Please ensure materials have a quantity greater than zero before closing.')
          return
        }

        this.isStorageAllocationModalOpen = true
      } else {
        this.UpdateForm(this.config.FORM_STATE_MAP.CLOSED)
      }
    },
    handleStorageAllocationSave (allocations) {
      this.storageBinsPayload = allocations.map(allocation => {
        const material = this.materialAllocationData[allocation.itemIndex]
        return {
          material_id: material.materialId,
          factory_storage_id: allocation.bin.id,
          quantity: allocation.quantity
        }
      })

      this.isStorageAllocationModalOpen = false
      this.UpdateForm(this.config.FORM_STATE_MAP.CLOSED)
    },
    async validateTableComponent (component, options = { checkRequired: true }) {
      if (component?.$options?.name !== 'table-template') return true
      return component.saveFormTemplate(options)
    },
    formatDuration (duration, durationType) {
      // If Days, just show as is
      if (durationType === 1) {
        return `${duration} ${duration === 1 ? 'Day' : 'Days'}`
      }

      // If Hours
      if (durationType === 2) {
        const days = Math.floor(duration / 24)
        const hours = duration % 24

        if (days > 0 && hours > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'} ${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        } else if (days > 0) {
          return `${days} ${days === 1 ? 'Day' : 'Days'}`
        } else {
          return `${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`
        }
      }

      // If Minutes
      if (durationType === 3) {
        const days = Math.floor(duration / (60 * 24))
        const hours = Math.floor((duration % (60 * 24)) / 60)
        const minutes = duration % 60

        const parts = []
        if (days > 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`)
        if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'Hr' : 'Hrs'}`)
        if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'Min' : 'Mins'}`)

        return parts.length > 0 ? parts.join(' ') : '0 Mins'
      }

      return `${duration} ${this.config.DURATION_TYPE[durationType]}`
    },
    setDefaultTab () {
      this.selectedTab = this.visibleTabs[0]?.id || null
    },
    handleDraftSubmit () {
      if (this.formData.form_type_id !== config.FORM_TEMPLATE_TYPE.JOF) {
        this.UpdateForm(config.FORM_STATE_MAP.OPEN)
        return
      }
      const materialField = this.findFieldId('MATERIALS')
      const materialComponent = materialField?.field_id ? this.$refs[materialField.field_id]?.[0] : null

      if (!this.isMaterialFieldEmptyCheck()) { materialComponent.openFlattenedBom({ submitAfterFlattening: true }) }
    },
    isMaterialFieldEmptyCheck () {
      const materialField = this.findFieldId('MATERIALS')
      const materialComponent = materialField?.field_id ? this.$refs[materialField.field_id]?.[0] : null
      const materialCompValue = materialComponent ? materialComponent.componentValue?.length > 0 : null
      if (!materialCompValue) {
        alert('Please add minimum one material before submitting')
        return true
      }
      return false
    },
    findFieldId (fieldType) {
      const materialField = this.templateField.find(
        (field) => field?.form_field?.key === fieldType
      )
      return materialField
    },
    confirmJofSubmit () {
      this.UpdateForm(config.FORM_STATE_MAP.OPEN)
    },
    goBackFromWorkflowDetails () {
      this.wfInstaceId = null
      this.workFlowVersionId = null
      const newQuery = { ...this.$route.query }
      delete newQuery.mInstDetails
      this.$router.replace({
        path: this.$route.path,
        query: newQuery
      })
    },
    async showWfInstanceDetails (obj) {
      if (this.wfInstaceId === obj.instanceId && this.selectedMaterial.name === obj.name) {
        return
      }
      this.sideBarLoading = true
      this.wfInstaceId = obj.instanceId
      this.selectedMaterial.number = obj.index + 1
      this.selectedMaterial.name = obj.name
      this.$refs.WorkflowDetailsPanel && await this.$refs.WorkflowDetailsPanel.getWorkFlowStepData(null)
      this.sideBarLoading = false
    },

    fetchMaterialLinks () {
      const formId = this.$route.params.formId
      GetJobOrderMaterialLinksInst(formId).then((ress) => {
        this.materialLinks = ress?.job_order_material_links || []
        this.getFormData()
      }).catch((err) => {
        console.log(err)
        alert('Failed to fetch job order material links')
      })
    },
    getUserTooltip (user) {
      return `${user.first_name} ${user.last_name}`
    },
    updatePartIdValues (values) {
      this.partIdValues = values
    },
    formatFileSize (size) {
      const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
      return (
        (size / Math.pow(1024, i)).toFixed(2) * 1 +
    ' ' +
    ['B', 'KB', 'MB', 'GB', 'TB'][i]
      )
    },
    getValidationSelector (formInput, form) {
      if (!formInput?.field_id) return null
      return form?.[formInput.field_id]?.[0]?.validationName || null
    },
    isFieldRequired (formInput) {
      return formInput?.required
    },
    setInputValidationState (formInput, form, hasError) {
      const selector = this.getValidationSelector(formInput, form)
      if (!selector) return
      if (hasError) {
        errorBorder(selector, true)
      } else {
        removeErrorBorder([selector])
      }
    },
    setFactoryValidationState (hasError) {
      const selector = this.$refs?.[config.FACTORY_FIELD_ID]?.[0]?.validationName
      if (!selector) return
      if (hasError) {
        errorBorder(selector, true)
      } else {
        removeErrorBorder([selector])
      }
    },
    highlightApiValidationErrors (errors = []) {
      errors.forEach((error) => {
        const field = this.templateField.find((item) => {
          return item.field_id === error.field_id ||
            item.field_id === error.fieldName ||
            item.field_name === error.field_name ||
            item.caption === error.field_name
        })
        const component = field?.field_id ? this.$refs[field.field_id]?.[0] : null
        const selector = component?.validationName || error.validationName
        if (selector) {
          errorBorder(selector, true, error.message)
        }
      })
    },
    validateInputData (formInput, form) {
      let hasError = false
      const isRequired = this.isFieldRequired(formInput)
      if (formInput?.form_field?.key === 'DOCUMENTS') {
        if (isRequired && (!form[formInput.field_id][0].componentValue || !form[formInput.field_id][0].componentValue.length)) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
      }
      if (formInput?.form_field?.key === 'USER') {
        if (isRequired && (!form[formInput.field_id][0].componentValue || !form[formInput.field_id][0].componentValue.length)) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
      }
      if (formInput?.form_field?.key === 'MULTI_USER') {
        if (isRequired && (!form[formInput.field_id][0].componentValue || !form[formInput.field_id][0].componentValue.length)) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      }
      if (formInput?.form_field?.key === 'BOOLEAN') {
        // we are comparing the value to null instead of checking if it is a falsy value cause the boolean component value will false in one case and it is valid value
        if (isRequired && form[formInput.field_id][0].componentValue === null) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      } else if (formInput?.form_field?.key === 'MATERIALS') {
        const materialValue = form[formInput.field_id][0]?.componentValue || []
        if (isRequired && (!Array.isArray(materialValue) || materialValue.length < 1)) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      } else if (formInput?.form_field?.key === 'TAGS') {
        if (isRequired && form[formInput.field_id][0].componentValue.length < 1) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
          hasError = true
        }
        this.setInputValidationState(formInput, form, hasError)
        return
      } else if (
        formInput?.form_field?.key === 'CONFIGURATION_LIST' &&
        !form[formInput.field_id][0]?.componentValue.length &&
        isRequired
      ) {
        this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        hasError = true
      }
      if (isRequired && !form[formInput.field_id][0].componentValue) {
        this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        hasError = true
      }
      this.setInputValidationState(formInput, form, hasError)
    },
    handleInputChange (data) {
      if (data.value === undefined) {
        this.$delete(this.metadataPayloadValueMap, data.field_id)
      } else {
        this.$set(this.metadataPayloadValueMap, data.field_id, data.value)
      }
    },
    getComponentGridClass (key) {
      const span = componentAlignment[key] || 1
      return span === 2 ? 'form-grid__item--span-2' : 'form-grid__item--span-1'
    },
    getValuesFromForm (key) {
      key = key.toLowerCase()
      switch (key) {
      case 'project':
        if (this.formData.project_id) {
          return this.formData?.core_project?.name
        } else {
          return '--'
        }
      case 'factory':
        if (this.formData.factory_id) {
          return this.formData?.core_factory?.name
        } else {
          return '--'
        }
      case 'created_on':
        if (this.formData.created_on) {
          return timeStampToDate(this.formData.created_on)
        }
        return '--'
      case 'created_by': {
        if (this.formData.created_by) {
          return this.formData.created_by_user.first_name + ' ' + this.formData.created_by_user.last_name
        }
        return '--'
      }
      case 'updated_on':
        if (this.formData.updated_on) {
          return timeStampToDate(this.formData.updated_on)
        }
        return '--'
      case 'updated_by': {
        if (this.formData.updated_by) {
          return this.formData.updated_by_user.first_name + ' ' + this.formData.updated_by_user.last_name
        }
        return '--'
      }
      }
    },
    getkeysFromForm (key) {
      key = key.toLowerCase()
      switch (key) {
      case 'created_on':
      case 'created_by':
      case 'updated_on':
      case 'updated_by':
        return null

      case 'project':
        return 'Project ID'
      case 'factory':
        return 'Factory'
      }
    },
    goBack () {
      const mInstDetailsId = this.$route.query.mInstDetails
      if (mInstDetailsId) {
        this.$router.replace(`/forms/template/${this.templateId}/form/${this.formData.id}/view?mInstDetails=${mInstDetailsId}`)
        return
      }
      this.$router.replace(`/forms/template/${this.templateId}/form/${this.formData.id}/view`)
    },
    validatePartIdValues () {
      let isValid = true
      for (const value of this.partIdValues) {
        if (!value.value) {
          this.validationErrors.push(`Please enter a value for ${value.caption} in form id`)
          isValid = false
        }
      }
      return isValid
    },
    getFormTemplateData () {
      this.loading = true
      this.loadEditForm = true
      getDetailFormTemplate(this.templateId, true).then(async (res) => {
        this.formTemplateData = res.core_form_templates_by_pk
        if (res.core_form_templates_by_pk?.core_sequence_id_template?.id_generation_rules) {
          this.partIdRules = res.core_form_templates_by_pk?.core_sequence_id_template?.id_generation_rules
        }
        this.formSequenceTemplate = this.formTemplateData.core_sequence_id_template
        this.loading = false
        this.loadEditForm = false
        this.workflowId = res.core_form_templates_by_pk.workflow_template_id
        this.workFlowVersionId = res.core_form_templates_by_pk.workflow_template?.workflow_versions[0].id
        this.wfTypeName = res.core_form_templates_by_pk.workflow_template?.type_value?.name
        const customListData = this.findUsedCustomListIds(res.core_form_templates_by_pk.template_versions)
        if (customListData.size > 0) {
          await this.getGivenCustomList([...customListData])
        }
        this.checkUsersAvailabilityWithWorkFlow()
        if (this.formData.status === config.FORM_STATE_MAP.DRAFT) {
          this.wftStartStages = res.core_form_templates_by_pk?.workflow_template?.workflow_versions[0]?.workflow_stages
          if (this.wftStartStages?.length === 1) {
            this.selectedStartingStep = this.wftStartStages[0]
          }
        }
      }).catch(() => {
        alert('Failed to fetch form template data')
      })
    },
    async UpdateForm (status, closeWFTform = false) {
      const workflowData = this.$refs.WorkflowDetailsPanel?.workflowData
      const selectedResource = this.$refs.WorkflowDetailsPanel?.selectedResource
      const newFiles = this.$refs.WorkflowDetailsPanel?.newFiles ?? []
      const existingFiles = this.$refs.WorkflowDetailsPanel?.existingFiles
      const selectedNextAction = this.$refs.WorkflowDetailsPanel?.selectedNextAction
      const nextStepData = this.$refs.WorkflowDetailsPanel?.nextStepData
      const existingUsers = this.$refs.WorkflowDetailsPanel?.existingUsers
      const wFstepUsers = this.$refs.WorkflowDetailsPanel?.wFstepUsers ?? []
      const hasError = validateWorkflowBeforeProceed({
        currentStatus: this.currentStatus,
        workflowData: workflowData,
        selectedResource: selectedResource,
        selectedNextAction: selectedNextAction,
        closeWFTform: closeWFTform,
        newFiles: newFiles,
        existingFiles: existingFiles,
        nextStepData: nextStepData,
        wFstepUsers: wFstepUsers
      })
      let isMaterialFieldEmpty = false
      if (status === config.FORM_STATE_MAP.DRAFT && this.formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF) { // submit is handled in handleDraftSubmit
        isMaterialFieldEmpty = this.isMaterialFieldEmptyCheck()
      }
      if (hasError || isMaterialFieldEmpty) return
      try {
        const hasWorkflowUpdates = this.currentStatus !== config.FORM_STATE_MAP.DRAFT &&
          (selectedNextAction || closeWFTform || newFiles.length || wFstepUsers.length)
        const canSkipEditFormApi = !this.updateFormDetails && hasWorkflowUpdates
        const form = this.$refs
        this.validationErrors = []
        if (!canSkipEditFormApi && this.partIdValues.length && status !== config.FORM_STATE_MAP.DRAFT && this.currentStatus === config.FORM_STATE_MAP.DRAFT) {
          this.validatePartIdValues()
        }
        if (!canSkipEditFormApi && parseInt(status) !== config.FORM_STATE_MAP.DRAFT) {
          for (const key of Object.keys(form)) {
            if (form[key] !== undefined) {
              const component = form[key][0]
              this.validateInputData(form[key][0]?.data, form)
              if (component?.validateSelection) {
                const isSelectionValid = await component.validateSelection()
                if (!isSelectionValid) {
                  this.validationErrors.push(`${component.data.caption} must use a last child selection`)
                }
              }
              if (component?.$options?.name === 'table-template') {
                const isValid = await this.validateTableComponent(component, { checkRequired: true })
                if (!isValid) {
                  return
                }
              }
            }
          }
        } else if (!canSkipEditFormApi) {
          if (!Object.keys(form).length) {
            this.validationErrors.push('Please fill atleast one field')
          }
        }
        if (!canSkipEditFormApi && status !== config.FORM_STATE_MAP.DRAFT && this.currentStatus === config.FORM_STATE_MAP.DRAFT && config.FORM_TEMPLATE_TYPE.JOF === this.formData.form_type_id) {
          const selectedFactoryId = this.$refs?.[config.FACTORY_FIELD_ID]?.[0]?.componentValue || this.formData.factory_id
          if (!selectedFactoryId) {
            this.validationErrors.push('Please select Factory')
            this.setFactoryValidationState(true)
          } else {
            this.setFactoryValidationState(false)
          }
        }
        if (!canSkipEditFormApi && this.changeInDueDate && !this.convertDueDate) {
          this.validationErrors.push('Please select due date')
          errorBorder('dueDate', true)
        } else {
          removeErrorBorder(['dueDate'])
        }
        if (this.validationErrors.length > 0) {
          this.validationErrors.forEach(error => alert(error))
          return
        }
        const metadataPayload = []
        let materialFieldIds = []
        // find the material feild id for jof
        // if its a jof then  need to exclude material fields and its data
        if (this.formData.form_type_id === this.config.FORM_TEMPLATE_TYPE.JOF) {
          materialFieldIds = getFieldIds({ templateFields: this.formTemplateData.template_versions[0]?.template_fields, fieldTypeId: config.FORM_TYPE.MATERIALS })
        }
        for (const [key, value] of Object.entries(this.metadataPayloadValueMap)) {
          //  in case jof material field is handled separatlely with the aid of another api
          if (this.formData.form_type_id === this.config.FORM_TEMPLATE_TYPE.JOF && materialFieldIds.includes(key)) {
            continue
          }
          // Prevent pushing undefined values in metadata payload
          if (value === undefined) {
            continue
          }
          metadataPayload.push({ field_id: key, value })
        }
        const payload = {
          formId: this.$route.params.formId,
          metadataPayload
        }
        if (!canSkipEditFormApi && this.changeInDueDate) {
          payload.dueDate = new Date(this.convertDueDate).toISOString()
        }
        if (!canSkipEditFormApi && parseInt(status) !== this.currentStatus) {
          payload.status = status
        }
        if (closeWFTform === true) delete payload.status
        if (status !== config.FORM_STATE_MAP.DRAFT && this.currentStatus === config.FORM_STATE_MAP.DRAFT && this.workflowId && !this.selectedStartingStep && !this.wfInstaceId) {
          alert('Please select a starting step for the workflow')
          return
        }
        if (this.wfInstaceId && this.currentStatus === config.FORM_STATE_MAP.DRAFT && !this.selectedStartingStep?.core_user_group?.name && !this.wFStartStepUsers?.length) {
          alert('Please select users for the next step')
          return
        }
        // this action only expected to be happened when the form is in draft state
        if (!this.wfInstaceId && this.selectedStartingStep && this.currentStatus === config.FORM_STATE_MAP.DRAFT && status !== config.FORM_STATE_MAP.DRAFT) {
          payload.stepId = this.selectedStartingStep.id
          payload.workflowStepAssignees = this.wFStartStepUsers.map((item) => {
            return ({ user_id: item.user_id, target_tenant_id: item.target_tenant_id, step_id: this.selectedStartingStep.id })
          })
        }
        if (this.currentStatus === config.FORM_STATE_MAP.DRAFT && this.partIdRules.length && status !== config.FORM_STATE_MAP.DRAFT) {
          const sequenceInput = this.partIdValues.map((value) => {
            return {
              value: value.value,
              delimiter: value.delimiter,
              sequence: value.sequence
            }
          })
          payload.formSequencePayload = sequenceInput
        }

        const loader = new Loader()
        loader.show()
        const updateWorkflowAction = async () => {
          if (hasWorkflowUpdates) {
            const { insertUsers = [], deleteUsers = [] } = !this.isExternalCollaborator && getWorkflowUserMappings({
              parentInstanceId: this.parentInstanceId,
              workflowData,
              wFstepUsers,
              startStepUsers: this.wFStartStepUsers, // case 2
              existingUsers,
              nextStepId: nextStepData.id,
              wfInstanceId: this.wfInstaceId,
              selectedStartingStep: this.selectedStartingStep,
              currentStatus: this.currentStatus,
              FORM_STATE_MAP: config.FORM_STATE_MAP
            })
            // if its a job order form then need to check whether the user has the permission to update the workflow action
            if (this.formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF && !workflowData.editInstance) {
              loader.hide()
              this.getFormData()
              return false
            }
            const res = await this.$refs.WorkflowDetailsPanel.updateWorkFlowAction(closeWFTform, insertUsers, deleteUsers)
            if (res?.message?.form_id && config.FORM_TEMPLATE_TYPE.JOF !== this.formData.form_type_id) {
              const templateId = workflowData.workflow_stage?.trigger_actions?.[0]?.core_form_template?.id
              loader.hide()
              this.$router.replace(`/forms/template/${templateId}/form/${res?.message?.form_id}/edit`)
              this.getFormData()
              return false
            }
          }
          return true
        }
        if (canSkipEditFormApi) {
          const shouldContinue = await updateWorkflowAction()
          if (!shouldContinue) return
          loader.hide()
          success('Workflow updated successfully')
          this.$router.push(`/forms/template/${this.templateId}/form/${this.$route.params.formId}/view`)
          return
        }
        //  uploading form material data
        if (materialFieldIds.length > 0 && this.currentStatus === config.FORM_STATE_MAP.DRAFT && status === config.FORM_STATE_MAP.DRAFT) {
          for (const field of materialFieldIds) {
            const materialData = form[field][0].componentValue
            if (isMatDataChange(this.metadataPayloadValueMap, field)) {
              await this.jofParentMaterialUpdate(materialData)
            }
          }
        }

        await EditForm(payload).then(async (res) => {
          if (res?.message?.message === 'Form Updated Successfully') {
            let shouldContinue
            try {
              shouldContinue = await updateWorkflowAction()
            } catch (err) {
              const message = 'Form updated successfully but an error occurred while updating the workflow action. Please refresh the page and check the workflow status.'
              warning(message)
              loader.hide()
            }
            if (!shouldContinue) return
            loader.hide()
            success(res?.message?.message ?? 'Successfully edited form')
            this.$router.push(`/forms/template/${this.templateId}/form/${this.$route.params.formId}/view`)
          } else if (res?.failedValidations?.length || res?.error?.length) {
            const err = res.failedValidations || res.error
            this.highlightApiValidationErrors(err)
            alert(`${err[0]?.field_name}: ${err[0]?.message}`)
            loader.hide()
          } else {
            alert('Failed to update form')
            loader.hide()
          }
        }).catch((err) => {
          console.log(err)
          loader.hide()
          alert('Failed to update form')
        })
      } catch (error) {
        console.log(error)
      }
    },
    getFormData (form) {
      this.templateId = this.$route.params.templateId
      this.templateName = this.$route.params.templateName
      const updatedFormId = form ? form.id : this.$route.params.formId
      this.loading = true
      this.loadEditForm = true
      GetFormDataByFormId(updatedFormId, this.isOnProjectLevel, this.isExternalCollaborator).then(
        async (res) => {
          this.formData = res.core_forms_by_pk
          if (this.formData.status === config.FORM_STATE_MAP.CLOSED) {
            this.$router.push('view')
          }
          if (this.formData.form_type_id === config.FORM_TEMPLATE_TYPE.JOF) {
            GetJobOrderMaterialLinksInst(updatedFormId).then((ress) => {
              this.materialLinks = ress?.job_order_material_links || []
              for (const item of res.core_forms_by_pk.forms_material_lists) {
                this.materialIdToDetailMap[item.core_material.id] = {
                  id: item.core_material.id,
                  name: item.core_material?.material_name,
                  stepId: item.core_material?.workflow_template?.workflow_versions[0]?.workflow_stages[0]?.id,
                  quantity: item.quantity
                }
              }
              const instanceIdFromQuery = this.$route.query.mInstDetails
              if (instanceIdFromQuery) {
                this.findMaterialNameForInstance(instanceIdFromQuery)
                this.activeMaterial = this.selectedMaterial.material_id
                this.showWfInstanceDetails({ index: this.selectedMaterial.number, instanceId: instanceIdFromQuery, name: this.materialIdToDetailMap[this.activeMaterial].name })
              }
            }).catch((err) => {
              console.log(err)
              alert('Failed to fetch job order material links')
            })
          }
          this.folderId = this.formData?.forms_document_list?.find(item => item?.document_version?.parent_id)?.document_version?.parent_id ?? null
          this.currentStatus = res.core_forms_by_pk.status
          this.convertDueDate = new Date(this.formData.due_date).toISOString().split('T')[0]
          const { formValueMap } = GetFormValueMap(res.core_forms_by_pk)
          this.formValueData = formValueMap
          this.wfInstaceId = res.core_forms_by_pk?.workflow_instance_id
          // parent instance id will come only for reopend forms
          this.parentInstanceId = res.core_forms_by_pk?.parent_form?.workflow_instance_id
          if (!this.parentInstanceId && this.$refs.WorkflowDetailsPanel?.workflowData.workflow_stage?.current_step_transition_history.length === 1) {
            this.$refs.WorkflowDetailsPanel.existingUsers = []
          }
          this.$refs.WorkflowDetailsPanel && await this.$refs.WorkflowDetailsPanel.getWorkFlowStepData(null)
          this.getFormTemplateData()
        }
      ).catch((err) => {
        console.log(err)
        alert('Failed to fetch form data')
      })
    },
    checkUsersAvailabilityWithWorkFlow () {
      // const stepUserMap = {}
      if (!this.workFlowVersionId) {
        return
      }
      getWorkflowStepWithUsers(this.workFlowVersionId).then((res) => {
        const stepUserMapSet = {}
        res.workflow_stages.forEach((stage) => {
          for (const userData of stage.core_user_group?.core_user_group_members ?? []) {
            this.selectedUserGroup.push(userData)
            if (stepUserMapSet[stage.id]) {
              stepUserMapSet[stage.id].add(userData.user_id)
            } else {
              stepUserMapSet[stage.id] = new Set([userData.user_id])
            }
          }
        })
        // checking for the first step with no users, respected stedid are stored
        const stepWithNoUsers = {}
        if (this.isOnProjectLevel) {
          for (const step in stepUserMapSet) {
            let confirmFlag = false
            for (const user of this.currentProject.project_user_associations) {
              if (stepUserMapSet[step].has(user.user_id)) {
                confirmFlag = true
                break
              }
            }
            if (!confirmFlag) {
              stepWithNoUsers[step] = step
            }
          }
        } else {
          for (const step in stepUserMapSet) {
            let confirmFlag = false
            for (const user of this.tenantUsersList) {
              if (stepUserMapSet[step].has(user.associated_user.id)) {
                confirmFlag = true
                break
              }
            }
            if (!confirmFlag) {
              stepWithNoUsers[step] = step
            }
          }
        }
        this.stepWithNoUsers = Object.keys(stepWithNoUsers)
        if (this.stepWithNoUsers?.length > 0) {
          confirmationDialog(
            `${this.stepWithNoUsers?.length} workflow steps have user groups with zero users from this project. Forms will be blocked at these steps until resolved. Are you sure to continue?`,
            (res) => {
              if (res) {
              }
            }
          )
        }
      })
    },
    addSelectedStep (stage) {
      this.selectedStartingStep = stage
    },
    findUsedCustomListIds (templateVersions) {
      const configIdSet = new Set()
      for (const templateVersion of templateVersions) {
        for (const field of templateVersion.template_fields) {
          if (field.field_type_id === config.FORM_TYPE.CONFIGRATION_LIST) {
            configIdSet.add(field.custom_list_id)
          }
        }
      }
      return configIdSet
    },
    async getGivenCustomList (ids) {
      const customListData = await getGivenCustomListsData(ids)
      const customListMap = {}
      for (const customList of customListData.core_custom_list) {
        customListMap[customList.id] = customList.custom_list_values
      }
      this.$store.dispatch('form/saveCustomListMap', customListMap)
    },
    handleUserSelection (data) {
      this.wFStartStepUsers = data.value.insert
      this.wFStartStepUsersDelete = data.value.delete
    },
    getStatusClass (status) {
      const statusClasses = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: 'in-progress',
        [config.FORM_STATE_MAP.APPROVED]: 'approved',
        [config.FORM_STATE_MAP.REJECTED]: 'rejected',
        [config.FORM_STATE_MAP.HOLD]: 'hold'
      }
      return statusClasses[status?.value] || 'in-progress'
    },
    getStatusIcon (status) {
      const statusIcons = {
        [config.FORM_STATE_MAP.IN_PROGRESS]: '✓',
        [config.FORM_STATE_MAP.APPROVED]: '✓',
        [config.FORM_STATE_MAP.REJECTED]: '✗',
        [config.FORM_STATE_MAP.HOLD]: '⏸'
      }
      return statusIcons[status?.value] || '✓'
    },
    getInstanceEditPermission (workflowData) {
      if (this.formData.form_type_id !== config.FORM_TEMPLATE_TYPE.JOF) {
        return true
      } else {
        if (this.user.tenantLevelRole === 'ADMIN' || this.user.projectLevelRole === 'ADMIN') {
          return true
        } else if (workflowData?.workflow_stage?.core_user_group?.core_user_group_members.some(item => item.user_id === this.user.userId)) {
          return true
        } else if (workflowData?.workflow_instance_steps[0]?.instance_step_assignees.some(item => item.user_id === this.user.userId)) {
          return true
        } else {
          return false
        }
      }
    },
    findMaterialNameForInstance (instanceId) {
      // Find the material name and index for the given workflow instance ID
      const materialMap = {}
      this.materialLinks.forEach(item => {
        const materialName = item.workflow_instance.core_material_master.material_name
        if (!materialMap[materialName]) {
          materialMap[materialName] = []
        }
        materialMap[materialName].push(item.workflow_instance)
      })

      // Search for the instance ID in the material map
      for (const [materialName, instances] of Object.entries(materialMap)) {
        const instanceIndex = instances.findIndex(inst => inst.id === instanceId)
        if (instanceIndex !== -1) {
          this.selectedMaterial.name = materialName
          this.selectedMaterial.number = instanceIndex + 1
          this.selectedMaterial.material_id = instances[instanceIndex].core_material_master.id
          break
        }
      }
    },
    selectTab (tabId) {
      if (this.$route.query.wfhistory) {
        const { wfhistory, ...rest } = this.$route.query
        this.$router.replace({
          path: this.$route.path,
          query: rest
        })
      }
      this.selectedTab = tabId
    },
    loadWorkflowData () {

    },
    jofParentMaterialUpdate (materialData = []) {
      if (materialData.length <= 0) {
        return
      }

      const payload = {
        items: formatMaterailData(materialData),
        form_id: this.$route.params.formId
      }
      return alterFlattenedBomMaterialsApi(payload)
    }

  },
  mounted () {
    this.setDefaultTab()
    this.getFormData()
  },
  // )
  watch: {
    selectedNextAction () {
      const container = this.$refs.userSelectionContainer
      if (container) {
        const select = container?.getElementsByTagName('select')
        select[0].style.padding = ' 0 0.85em'
        select[0].style.height = '25px'
        select[0].style.fontSize = '.8rem'
        const textInput = container.querySelector('input[type="text"]')
        textInput.style.padding = '0 0.85em'
        textInput.style.height = '25px'
        textInput.style.fontSize = '.8rem'
        const badge = container.querySelectorAll('.form-user-bedge') ?? []
        badge.forEach((item) => {
          item.style.fontSize = '.8rem'
        })
      }
    },
    visibleTabs () {
      this.setDefaultTab()
    }
  }
}
</script>

<style lang="scss" scoped >
 .step-name-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 75%;
}
.btn-2 {
  font-size: var(--text-s);
  width: fit-content;
  height: fit-content;
}

.reason {
  width: 400px;
  max-width: 400px;
  max-height: 20vh;
}

@media (min-width: 1600px) {
  .view-form--maincontainer {
    margin-right: auto;
    margin-left: auto;
    // width: 80%;
  }
}

.view-form {
  &--container {
    padding: 20px;
    margin-top: 10px;
    flex: 1;
    // margin: 0 auto;
    height: 100%;
    overflow-y: auto;
    // box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(225, 225, 225, 0.842);
    margin-top: 10px;
    border-radius: .8rem;
    background-color: var(--white);
  }
  &--sideBar {
    margin-top: 10px;
    flex: 1;
    height: calc(100%);
    border-radius: 6px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    // // background: white;
    // & .activeStep {
    //   display: flex;
    //   flex-direction: column;
    //   gap: 20px;
    //   box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    //   padding: 20px;
    //   background: white;
    //   border-radius: 6px;
    //   margin: 2px 4px 4px 4px;
    // }

    & select {
      border: var(--border);
      background-color: transparent;
      border-radius: 4px;
      // padding: 0 6px;
      // height: 20px;
      // width: 100px;
      outline: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 15px;
      &:focus {
        border-color: var(--brand-color);
      }
    }
  }
  &--maincontainer{
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 20px;
    height: calc(100% - 60px);
    justify-items: center;
    background-color: var(--white);
  }

  &--elements{
    height: -webkit-fill-available;
  }
  // .form-grid {
  //   display: grid;
  //   grid-template-columns: repeat(2, minmax(0, 1fr));
  //   gap: 15px 8px;
  //   align-items: start;
  // }
  // .form-grid__item {
  //   display: flex;
  //   flex-direction: column;
  //   gap: 8px;
  //   width: 100%;
  //   &:last-child{
  //     margin-bottom: 1rem;
  //   }
  // }
  // .form-grid__item--span-2 {
  //   grid-column: span 2;
  // }
  // .form-grid__item--span-1 {
  //   grid-column: span 1;
  // }
  // @media (max-width: 500px) {
  //   .form-grid {
  //     grid-template-columns: 1fr !important;
  //   }

  //   .form-grid__item,
  //   .form-grid__item--span-1,
  //   .form-grid__item--span-2 {
  //     grid-column: 1 / -1 !important;
  //   }
  // }
& .imp > .label{
      &::after {
        content: '*';
        color: var(--brand-color-1);
        font-size: 1.2em;
        margin-left: 0.1em;
      }
    }
}

.view-form .form-grid__item {
  min-width: 0;
}

.view-form .form-grid__item ::v-deep .form-input {
  width: 100%;
}

.view-form .form-grid__item ::v-deep .form-input__label {
  min-height: 18px;
  line-height: 18px;
  margin-bottom: 6px;
}

.view-form .form-grid__item ::v-deep .form-input__caption {
  line-height: 18px;
}

.view-form .form-grid__item ::v-deep .form-input input,
.view-form .form-grid__item ::v-deep .form-input select {
  height: 38px;
  min-height: 38px;
}

.view-form .form-grid__item ::v-deep .form-input textarea {
  min-height: 120px;
}

.status-label {
  display: inline-block;
  background-color: #e8f5e8;
  color: #4a7c59;
  padding: 2px 0px;
  border-radius: 8px;
  font-size: var(--text-xs1);
  font-weight: 500;
}
.comment-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 12px;
  z-index: 9;
  background: var(--white);
  cursor: pointer;
  border-radius: 50%;
  height: 45px;
  width: 45px;
  border: none;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
  & img {
    width: 30px;
    height: 30px;
  }
  &:hover {
    background: var(--brand-color);
    & img {
      filter: invert(1);
    }
  }
  &:active {
    box-shadow: inset 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
  }
}
.form-comment {
  position: fixed;
  bottom: 30px;
  right: -700px;
  top: 130px;
  width: 400px;
  z-index: 9;

  transition: right 0.8s ease-in-out;
  &[arial-data="open"] {
    right: 20px;
  }
}
.status-tag {
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  display: inline-block;
  min-width: 100px;
  text-align: center;
}
.not-started {
  background-color: rgba(255, 0, 0, 0.1);
  color: purple;
  max-width: 150px;
}

.completed {
  background-color: rgba(0, 128, 0, 0.1);
  color: green;
  max-width: 150px;
}

.ongoing {
  background-color: rgba(255, 165, 0, 0.1);
  color: orange;
  max-width: 150px;
}

.cancelled {
  background-color: rgba(198, 39, 52, 0.1);
  color: red;
}

.tabs {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  font-family: sans-serif;
}

.tab-headers {
  display: flex;
  font-size:var(--text-xs2);
  background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
}

.tab-header {
  padding: 12px 18px;
  cursor: pointer;
  flex: 1;
  text-align: center;
  justify-content: center;
  transition: background 0.3s;
}

.tab-header:hover {
  background-color: #e0e0e0;
}

.tab-header.active {
  background-color: #fff;
  font-weight: 400;
  border-bottom: 2px solid var(--brand-color);
}
.activeStep {
  padding: 16px 20px 20px;
  // background: #fff;
  // border-radius: 6px;
  // box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 10px;
  &-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: -webkit-fill-available;
    overflow: auto;
    background: #fff;
    border-radius: 6px;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);

  }
  @media (max-height: 500px) {
    max-height: 455px;
    overflow-y: scroll;
  }
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  & .step-name {
  font-size: var(--text-4xl);
  font-weight: 600;
  max-width: 250px;
}
}

.dept {
  font-size: var(--text-s);
  color: #696969;
  font-weight: 400;
}
.border {
  // box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
  border-top: 1px solid #DCDCDC;
}
.date-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.label-2 {
  font-size: var(--text-xs2);
  color: #696969;
  // font-weight: 500;
  margin-bottom: 4px;
}

.date-block {
  display: flex;
  flex-direction: column;
  font-size: var(--text-base);
}

.date-detail {
  margin-right: 2px;
  font-size: var(--text-s);
  color: #696969;
  margin-bottom: 2px;
}
.date-value {
  font-size: var(--text-s);
}

.duration-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.duration-value {
  // color: #696969;
  font-size: var(--text-s);
  font-weight: 500;
  // margin-top: -5px;
}

.upload-row {
  min-height: 90px;
  display: flex;
  gap: 15px;
  // padding-top: 16px;
  // align-items: flex-start;
  // border-top: 1px solid #ccc;
  // margin-top: 12px;
}

.upload-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #ccc;
  padding-right: 10px;
  width: 25%;
  height: 90px;
  margin-right: 10px;
  text-align: center;
  align-items: center;
}
.upload-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
  margin-bottom: 8px;
}

.uploaded-files-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.uploaded-header {
  font-weight: 500;
  margin-bottom: 8px;
  font-size: var(--text-xs2);
  white-space: nowrap;
  color: #696969;
  font-weight: 500;
}

.uploaded-list {
  overflow-y: auto;
  max-height: 120px;
  padding-right: 8px;
}
.no-files {
  font-size: var(--text-xs1);
// display: flex;
// align-items: center;
// justify-content: center;
height: 120px;
padding-right: 8px;
}

.uploaded-file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
  font-size: var(--text-base);
  color: #333;
&  .step-name{
   white-space: nowrap;
  font-size: .85em;
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30%;
}
}

.file-name {
  font-size: var(--text-xs1);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
}

.file-status {
  white-space: nowrap;
  font-size: var(--text-m);
  color: #888;
}

.loader {
  width: 14px;
  height: 14px;
  border: 2px solid #ccc;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
}
.error-text {
  color: red;
  font-size: var(--text-xs1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.next-action-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.next-action-header .label {
  font-weight: 500;
  font-size: var(--text-s);
  white-space: nowrap;
  margin-right: 12px;
}

.next-action-line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
  margin-top: 1px;
}

.next-action-desc {
  font-size: var(--text-xs2);
  color: #666;
}

.next-action-select {
  // width: fit-content;
  // padding: 6px 10px;
  font-size: var(--text-base);
  border: 1px solid #ccc;
  border-radius: 4px;
}
.upload-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-header .label {
  font-weight: 500;
  font-size: var(--text-s);
  white-space: nowrap;
  margin-right: 12px;
}

.upload-line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
  margin-top: 1px;
}

.upload-desc {
  font-size: var(--text-xs2);
  color: #666;
  margin: 0 0 8px 0;
}

.upload-select {
  // width: fit-content;
  // padding: 6px 10px;
  font-size: var(--text-base);
  border: 1px solid #ccc;
  border-radius: 4px;
}

// remvove these lines when latest ui of form is promoted to staging: start of lines
.view-form .form-autogenerated {
  border-radius: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;

  .autogenerated,
  .span-div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .label {
    color: #2d2c2c;
    font-size: var(--text-m);
    font-weight: 500;
    margin-bottom: 4px;
  }

  .value {
    background-color: rgb(173 208 250 / 40%);
    padding: 5px 8px;
    border: 1px solid #e9e9e9;
    border-radius: 6px;
    color: #3046ea;
    font-size: var(text-s);
    min-width: 0;
    border-color: rgba(151, 179, 249, .38);
  }
}
// remvove these lines when latest ui of form is promoted to staging: end of lines

.tab-body-parent{
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: -webkit-fill-available;
    overflow: auto;
}
.resource-item{
  display: flex;
  align-items: center;
gap: 10px;
&-btn2{
  padding: 0px 4px;
border: 1px solid #ccc;
border-radius: 2px;
font-size: var(--text-base);
border-radius: 3px;
border-width: 0px;
cursor: pointer;
background: transparent;
&:hover{
  border-width:1px;
}
&:active{
  transform: scale(0.9);
}
}
   &-btn{
padding: 0px 4px;
border: 1px solid #ccc;
border-radius: 4px;
font-size: var(--text-base);
border-radius:3px;
cursor: pointer;
background: transparent;
&:hover{
background: #000000;
border-color: #ccc;
color:white;
}
&:active{
  transform: scale(0.9);
}
   }
}
.fill-qc-btn {
  background: #f5f5f5;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: var(--text-s);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(158, 158, 158, 0.3);
  box-shadow: 0 1px 2px rgba(102, 126, 234, 0.2);

  &:hover {
    background: #e8e8e8;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(211, 219, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(189, 191, 197, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(189, 191, 197, 0.3);
  }
}

@media (max-width: 500px) {
  .view-form--maincontainer {
    flex-direction: column;
    padding: 12px;
  }

  .view-form .form-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .view-form .form-grid__item,
  .view-form .form-grid__item--span-1,
  .view-form .form-grid__item--span-2 {
    grid-column: 1 / -1 !important;
  }
}
</style>
